import { Onfido } from 'onfido-sdk-ui';
import './onfido.scss';
import logger from "../../contexts/Logger";

export const mountOnfido = (/** @type {string} */ mobileNumber, /** @type {string} */ token, /** @type {(faceId: string) => void}} */ onSuccess) => {
    return Onfido.init({
        version: "14.49.0",
        crossDevicePolicy: 'force',
        steps: [
            {
                type: 'face'
            }
        ],
        smsNumberCountryCode: 'GB',
        _crossDeviceLinkMethods: ['qr_code', 'sms'],
        userDetails: {
            smsNumber: mobileNumber
        },
        token: token,
        containerId: 'onfido-mount',
        onComplete: function (data) {
            // @ts-expect-error This is legitimate but TypeScript doesn't like use of `unknown` - fix with a type guard or Zod schema
            onSuccess(data.face.id);
        },
        onError: function (exception) {
            // todo: what shall we show the user here?
          
        },
        customUI: {
            borderRadiusButton: "6.5rem",
            colorAccent: "#286B6E",
            colorBackgroundButtonPrimary: "#286B6E",
            colorBackgroundButtonPrimaryActive: "#21595b",
            colorBackgroundButtonPrimaryHover: "#21595b",
            colorContentButtonPrimaryText: "white",
            colorBackgroundButtonSecondary: "#E6E5E1",
            colorBackgroundButtonSecondaryActive: "#d1d2d6",
            colorBackgroundButtonSecondaryHover: "#ECECE9",
            colorContentButtonSecondaryText: "#30384a",
            colorBorderButtonSecondary: "#d1d2d6",
            colorBorderButtonSecondaryActive: "#21595b",
            colorBorderButtonSecondaryHover: "#21595b",
            colorBackgroundButtonIconActive: "#21595b",
            colorBackgroundButtonIconHover: "#21595b",
            colorBackgroundDocTypeButton: "transparent",
            colorBackgroundDocTypeButtonActive: "#f6f6f4",
            colorBackgroundDocTypeButtonHover: "#f6f6f4",
            colorBackgroundSurfaceModal: "white",
            colorBackgroundSelector: "#286B6E",
            colorBackgroundLinkActive: "transparent",
            colorBackgroundLinkHover: "transparent",
            colorBackgroundInfoPill: "white",
            colorBackgroundIcon: "#f6f6f4",
            colorBorderButtonPrimary: "transparent",
            colorBorderButtonPrimaryActive: "#286B6E",
            colorBorderButtonPrimaryHover: "#286B6E",
            colorBorderDocTypeButton: "#f6f6f4",
            colorBorderDocTypeButtonActive: "#f6f6f4",
            colorBorderDocTypeButtonHover: "#f6f6f4",
            colorBorderLinkUnderline: "transparent",
            colorBorderSurfaceModal: "black",
            colorContentBody: "#30384a",
            colorContentDocTypeButton: "#30384a",
            colorContentInfoPill: "#286B6E",
            colorContentLinkText: "#286B6E",
            colorContentLinkTextHover: "#21595b",
            colorContentSubtitle: "#30384a",
            colorContentTitle: "#30384a",
            colorIcon: "#286B6E",
            colorInputOutline: "#286B6E",
            fontFamilyBody: "Inter, sans-serif",
            fontFamilySubtitle: "Inter, sans-serif",
            fontFamilyTitle: "Libre Caslon Text, serif",
            fontSizeBody: "16px",
            fontSizeSubtitle: "20px",
            fontSizeTitle: "24px",
            fontWeightBody: 500,
            fontWeightSubtitle: 400,
            fontWeightTitle: 400,
        },        
        language: {
            locale: 'en_GB',
            phrases: {
                //@ts-expect-error I think the SDK may be out of date
                cross_device_intro: {
                    button_primary: "OK",
                    list_accessibility: " ",
                    list_item_send_phone: "On the next page, you'll need to scan a QR code with your mobile. You'll also be able to request a link instead",
                    list_item_open_link: "We'll then ask you to use your mobile to take a selfie",
                    list_item_finish: "When you're done, check back here to continue your verification.",
                    subtitle: " ",
                    title: "How it works"
                },
                //@ts-expect-error I think the SDK may be out of date
                cross_device_return: {
                    body: "Your dashboard may take a few seconds to update",
                    subtitle: "You can now return to your dashboard to continue",
                    title: " "
                },
                //@ts-expect-error I think the SDK may be out of date
                cross_device_error_desktop: {
                    subtitle: "The link only works on mobile devices",
                    title: "Something's gone wrong"
                },
                //@ts-expect-error I think the SDK may be out of date
                cross_device_error_restart: {
                    subtitle: "You'll need to restart your verification on your computer",
                    title: "Something's gone wrong"
                },
                //@ts-expect-error I think the SDK may be out of date
                cross_device_checklist: {
                    button_primary: "Submit your verification",
                    info: "Tips",
                    list_item_doc_multiple: "Documents",
                    list_item_doc_one: "Document uploaded",
                    list_item_selfie: "Selfie uploaded",
                    list_item_video: "Video",
                    subtitle: "You've sent us everything we need",
                    title: " " //One final step
                },
                //@ts-expect-error I think the SDK may be out of date
                generic: {
                    errors: {
                        sms_overuse: {
                            instruction: " ",
                            message: "You've now sent the maximum number of verification links."
                        }
                    }
                },
                //@ts-expect-error I think the SDK may be out of date
                get_link: {
                    alert_wrong_number: "Check that your number is correct",
                    button_copied: "Copied",
                    button_copy: "Copy",
                    button_submit: "Send link",
                    info_qr_how: "How do I scan a QR code?",
                    info_qr_how_list_item_camera: "Open your camera app or a QR code scanning app if you have one and point your camera straight at the QR code - it may take a few seconds",
                    info_qr_how_list_item_download: "You may need to tap a link if the page doesn't open automatically.",
                    link_divider: "Or you can use an alternative method",
                    link_qr: "Scan a QR code",
                    link_sms: "Text me a link ",
                    link_url: "Copy the link",
                    loader_sending: "Sending",
                    number_field_input_placeholder: "Enter mobile number",
                    number_field_label: "Enter your mobile number:",
                    subtitle_qr: "Please scan this QR code with your phone's camera or a QR code reading app.",
                    subtitle_sms: "Click below to send a one-time secure link to your mobile",
                    subtitle_url: "Send this one-time link to your phone",
                    title: " ", //Get your secure link
                    url_field_label: "Copy the link to your mobile browser"
                },
                //@ts-expect-error I think the SDK may be out of date
                photo_upload: {
                    body_bank_statement: "Provide the whole document page for best results",
                    body_benefits_letter: "Provide the whole document page for best results",
                    body_bill: "Provide the whole document page for best results",
                    body_government_letter: "Provide the whole document page for best results",
                    body_id_back: "Upload back of card",
                    body_id_front: "Upload front of card",
                    body_license_back: "Take a photo of the back of your licence",
                    body_license_front: "Take a photo of the front of your licence",
                    body_passport: "Upload passport photo page",
                    body_selfie: "Upload a selfie",
                    body_tax_letter: "Provide the whole document page for best results",
                    button_take_photo: "Take photo",
                    button_upload: "Upload",
                    title_selfie: "Selfie"
                },
                //@ts-expect-error I think the SDK may be out of date
                selfie_capture: {
                    alert: {
                        camera_inactive: {
                            detail: "Check that it is connected and functional. You can also <fallback>continue verification on your phone<\/fallback>",
                            detail_no_fallback: "Make sure your device has a working camera",
                            title: "Camera not working?"
                        },
                        camera_not_working: {
                            detail: "It may be disconnected. <fallback>Try using your phone instead<\/fallback>.",
                            detail_no_fallback: "Make sure your device's camera works",
                            title: "Camera not working"
                        },
                        timeout: {
                            detail: "Remember to press the button when you're done. <fallback>Redo video actions<\/fallback>",
                            title: "Looks like you took too long"
                        }
                    },
                    button_accessibility: "Take a photo",
                    frame_accessibility: "View from camera",
                    title: "Keep your face within the oval"
                },
                //@ts-expect-error I think the SDK may be out of date
                selfie_confirmation: {
                    image_accessibility: "Photo of your face",
                    subtitle: "Make sure your entire face is visible",
                    title: "Check your selfie"
                },
                //@ts-expect-error I think the SDK may be out of date
                selfie_intro: {
                    button_primary: "Continue",
                    list_accessibility: "Tips to take a good selfie",
                    list_item_face_forward: "Face forward and make sure your eyes are clearly visible",
                    list_item_no_glasses: "Remove your glasses, if necessary",
                    subtitle: "We'll compare this with your document",
                    title: "Take a selfie"
                },
                //@ts-expect-error I think the SDK may be out of date
                sms_sent: {
                    info: "Tips",
                    info_link_expire: "The verification link will direct you to id.onfido.com and expire in 1 hour",
                    info_link_window: "Keep this window open while using your mobile",
                    link: "Try another method",
                    subtitle_minutes: "It may take a few minutes to arrive",
                    title: "Check your mobile"
                },
                //@ts-expect-error I think the SDK may be out of date
                switch_phone: {
                    info: "Tips",
                    info_link_expire: "Your mobile link will expire in one hour",
                    info_link_refresh: "Don't refresh this page",
                    info_link_window: "Keep this window open while using your mobile",
                    link: "Cancel",
                    subtitle: "Once you've finished we'll take you to the next step",
                    title: "Connected to your mobile"
                },
                //@ts-expect-error I think the SDK may be out of date
                upload_guide: {
                    button_primary: "Upload photo",
                    image_detail_blur_alt: "Example of a blurry document",
                    image_detail_blur_label: "All details must be clear - nothing blurry",
                    image_detail_cutoff_label: "Show all details - including the bottom 2 lines",
                    image_detail_glare_label: "Move away from direct light - no glare",
                    image_detail_good_label: "The photo should clearly show your document",
                    subtitle: "Scans and photocopies are not accepted",
                    title: "Upload passport photo page"
                }
            }
        }
    });
}